export const START_WEEK = {
  MONDAY: 'monday',
  SUNDAY: 'sunday',
} as const;

export const SELECTORS = {
  CALENDAR_HEADER: '.dtp-calender thead tr',
} as const;

export const WORK_TYPE = {
  SINGLE: 'single',
  MULTI: 'multi',
} as const;
